import type { FieldValidator } from 'final-form';
import { trim } from 'lodash';
import type { FC, ReactElement } from 'react';
import { Field, Form } from 'react-final-form';
import type { FormProps } from 'react-final-form';

import { doFieldFormatting } from 'common/utils/formats';
import type { InputProps } from 'common/utils/validations';
import { doFormValidations, doFieldValidations } from 'common/utils/validations';

const ValidationField: FC<InputProps<any, any, any>> = (props): ReactElement => {
    const { validations = [], t, formats = [], trimWhiteSpaces, ...rest } = props;

    if (trimWhiteSpaces) {
        formats.push(trim);
    }

    return <Field validate={doFieldValidations(validations, t)} format={doFieldFormatting(formats)} {...rest} />;
};

const ValidationForm = <FormValues,>(
    props: FormProps<FormValues> & { validations?: FieldValidator<any>[] } & { t?: Function }
): ReactElement => {
    const { validations = [], t, ...rest } = props;

    return <Form<FormValues> validate={doFormValidations(validations, t)} {...rest} />;
};

export { ValidationField as Field, ValidationForm as Form };
